import React from 'react';
import Routes from './routes'

import './assets/fonts/Azonix.otf';
import './globals.scss'

function App() {
  return (
    <Routes />
  );
}

export default App;
